import { createContext, useContext, useEffect, useState } from 'react'
import { api } from '../services/api'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api
      .get('/auth/me')
      .then((data) => setUser(data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false))
  }, [])

  const signup = async (email, password, accessPassword) => {
    const data = await api.post('/auth/signup', { email, password, accessPassword })
    setUser(data.user)
    return data.user
  }

  const login = async (email, password) => {
    const data = await api.post('/auth/login', { email, password })
    setUser(data.user)
    return data.user
  }

  const logout = async () => {
    await api.post('/auth/logout')
    setUser(null)
  }

  const submitStep = async (payload) => {
    const data = await api.post('/auth/onboarding', payload)
    setUser(data.user)
    return data.user
  }

  const applyUser = (next) => {
    if (next) setUser(next)
  }

  const value = { user, loading, signup, login, logout, submitStep, applyUser }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  return useContext(AuthContext)
}
